module.exports = __webpack_public_path__ + "img/belveder.d9f21140.jpg";